import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";

const api = "https://apideneme.com.tr/api/item";

const EditItem = () => {
    const [id, setId] = useState(""); // id'yi burada tanımlıyoruz
    const [userId, setUserId] = useState(""); // item'den gelen user_id'yi burada tanımlıyoruz
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [image, setImage] = useState(null);
    const [error, setError] = useState(""); // Hata mesajlarını göstermek için ekledik
    const navigate = useNavigate();
    const { id: paramId } = useParams();

    useEffect(() => {
        const storedUserId = Cookies.get("user_id");
        if (!storedUserId) {
            navigate("/login"); // Giriş yapmamışsa login sayfasına yönlendir
        }
        // Cookie'den user_id'yi alıyoruz
        setUserId(storedUserId); 
    }, [navigate]);

    const update = async (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append("id", id); // id'yi formData'ya ekliyoruz
        formData.append("name", name);
        formData.append("description", description);
        formData.append("price", price);
        if (image) {
            formData.append("image", image); // Resmi ekle
        }
    
        // FormData içeriğini konsola yazdır
        for (const pair of formData.entries()) {
            console.log(`${pair[0]}: ${pair[1]}`);
        }
    
        try {
            const response = await axios.post(`${api}/update`, formData, {  // POST kullanıyoruz
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            console.log("Güncelleme yanıtı:", response.data);
            //alert("Veri başarıyla güncellendi!");
            
            // Kullanıcı ID'sine göre yönlendirme
            const userId = Cookies.get("user_id");
            if (userId === "1") {
                navigate("/items"); // Adminse /items sayfasına yönlendir
            } else {
                navigate("/user-items"); // Admin değilse /user-items sayfasına yönlendir
            }
        } catch (error) {
            console.error("Güncelleme sırasında hata oluştu:", error);
            setError("Güncelleme işlemi başarısız oldu!"); // Hata mesajı gösteriyoruz
        }
    };
    

    useEffect(() => {
        const getItemById = async () => {
            try {
                const response = await axios.get(`${api}/${paramId}`, {
                    params: { user_id: Cookies.get("user_id") }, // Cookie'den user_id'yi alıyoruz
                });
                setId(response.data.id); // id'yi alıyoruz
                setName(response.data.name);
                setDescription(response.data.description);
                setPrice(response.data.price);
                setUserId(response.data.user_id); // Item'dan gelen user_id'yi set ediyoruz
            } catch (error) {
                console.error("Veri alınırken hata:", error);
                setError("Veri alınırken bir hata oluştu!"); // Hata mesajı gösteriyoruz
            }
        };

        getItemById();
    }, [paramId]); // paramId değiştiğinde yeniden çalışacak

    const handleBack = () => {
        const userId = localStorage.getItem('user_id');
        if (userId === "1") {
            navigate("/items"); // Adminse items sayfasına yönlendir
        } else {
            navigate("/user-items"); // Diğer kullanıcılar için user-items sayfasına yönlendir
        }
    };

    return (
        <div>
            <button 
                className="btn btn-secondary position-absolute" 
                style={{ top: '10px', right: '10px' }} 
                onClick={handleBack}
            >
                BACK
            </button>
            
            <h3>Eleman Düzenle</h3>
            <div className="container">
                <div className="row d-flex align-items-center justify-content-center">
                    <div className="col-md-6">
                        {error && <p className="text-danger">{error}</p>} {/* Hata mesajını göster */}
                        <form onSubmit={update}>
                            <div className="mb-3">
                                <label className="form-label">ID</label>
                                <input
                                    value={id}
                                    type="text"
                                    className="form-control"
                                    disabled // ID'yi değiştirmesini engelliyoruz
                                />
                            </div>

                            {/* User ID kısmı eklendi ve sadece admin için görünecek */}
                            {Cookies.get("user_id") === "1" && (
                                <div className="mb-3">
                                    <label className="form-label">User ID</label>
                                    <input
                                        value={userId}
                                        type="text"
                                        className="form-control"
                                        disabled // User ID'yi değiştirmesini engelliyoruz
                                    />
                                </div>
                            )}

                            <div className="mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <input
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    type="text"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Price</label>
                                <input
                                    value={price}
                                    onChange={(e) => setPrice(e.target.value)}
                                    type="number"
                                    className="form-control"
                                    required
                                    style={{
                                        backgroundColor: "#f0f8ff",
                                        border: "1px solid #ced4da",
                                        color: "#333",
                                    }}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Image</label>
                                <input
                                    type="file"
                                    onChange={(e) => setImage(e.target.files[0])}
                                    className="form-control"
                                />
                            </div>

                            <button type="submit" className="btn btn-primary">
                                Kaydet
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditItem;
